const select2 = () => {
  document.addEventListener('DOMContentLoaded', function () {
    jQuery('.select-2').select2({
      minimumResultsForSearch: Infinity,
    });

    jQuery('.products-filter__sorting .select-2').on('select2:select', function () {
      this.form.submit();
    });

    const $regionSelect = jQuery('#offline_lesson_region');
    const $placeSelect = jQuery('#offline_lesson_place');
    const $dateSelect = jQuery('#offline_lesson_date');
    const $timeSelect = jQuery('#offline_lesson_time');
    let placesRequest, datesRequest, timesRequest;
    const showError = (select, xhr, status) => {
      if (status === 'abort') return;
      const message = xhr.status === 401
        ? 'Сесія завершилась. Оновіть сторінку та увійдіть знову.'
        : 'Не вдалося завантажити. Оберіть попереднє поле повторно.';
      select.empty().append(new Option(message, '')).prop('disabled', true).trigger('change');
      let notice = select.parent().find('.offline-ajax-error');
      if (!notice.length) notice = jQuery('<p class="offline-ajax-error" role="alert"></p>').insertAfter(select.next('.select2'));
      notice.text(message);
    };

    $placeSelect.select2({
      minimumResultsForSearch: Infinity,
      placeholder: 'Виберіть Місто',
      disabled: true
    });

    $regionSelect.select2({
      minimumResultsForSearch: Infinity,
      placeholder: 'Виберіть Регіон',
    });

    $dateSelect.select2({
      minimumResultsForSearch: Infinity,
      placeholder: 'Виберіть Дату',
      disabled: true
    });

    $timeSelect.select2({
      minimumResultsForSearch: Infinity,
      placeholder: 'Виберіть Час',
      disabled: true
    });


    $regionSelect.on('select2:select', function () {
      placesRequest?.abort(); datesRequest?.abort(); timesRequest?.abort();
      jQuery('.offline-ajax-error').remove();
      const regionId = jQuery(this).val();

      $placeSelect.prop('disabled', true).empty().trigger('change');
      $dateSelect.prop('disabled', true).empty().trigger('change');
      $timeSelect.prop('disabled', true).empty().trigger('change');

      if (!regionId) return;

      placesRequest = jQuery.ajax({
        url: rcData.ajaxUrl,
        type: 'POST',
        data: {
          action: 'get_places_by_region',
          region_id: regionId,
        },
        beforeSend: function () {
          const loadingOption = new Option('Завантаження...', '', false, false);
          $placeSelect.append(loadingOption).trigger('change');
        },
        success: function (response) {
          if (!response.success || !response.data) { showError($placeSelect, {}, 'error'); return; }

          const data = response.data;
          const places = data.places || [];

          $placeSelect.empty();
          if (places.length) {
            $placeSelect.append('<option value="">Виберіть Місто</option>');
            places.forEach(function (place) {
              const option = new Option(place.text, place.id, false, false);
              $placeSelect.append(option);
            });
            $placeSelect.prop('disabled', false).trigger('change');
          } else {
            const option = new Option('Немає доступних локацій', '', false, false);
            $placeSelect.append(option).prop('disabled', true).trigger('change');
          }
        },
        error: (xhr, status) => showError($placeSelect, xhr, status)
      });
    });




    const placeSelect = jQuery('#offline_lesson_place');
    const dateSelect  = jQuery('#offline_lesson_date');
    const timeSelect  = jQuery('#offline_lesson_time');

    placeSelect.on('select2:select', function () {
      datesRequest?.abort(); timesRequest?.abort();
      jQuery('.offline-ajax-error').remove();
      const placeId = jQuery(this).val();


      dateSelect.empty().append(new Option('Завантаження...', '', false, false)).prop('disabled', true).trigger('change');
      timeSelect.empty().append(new Option('Завантаження...', '', false, false)).prop('disabled', true).trigger('change');

      if (!placeId) return;

      datesRequest = jQuery.ajax({
        url: rcData.ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'get_course_dates_by_place',
          place_id: placeId
        },
        success: function(response) {
          if (!response.success || !response.data) { showError(dateSelect, {}, 'error'); return; }

          const dates = response.data.dates || [];

          dateSelect.empty();
          if (dates.length) {
            dateSelect.append('<option value="">Виберіть Дату</option>');
            dates.forEach(function (item) {
              const option = new Option(item.date, item.id, false, false);
              dateSelect.append(option);
            });
            dateSelect.prop('disabled', false);
          } else {
            dateSelect.append(new Option('Немає доступних дат', '', false, false)).prop('disabled', true);
          }


          dateSelect.trigger('change.select2');
          timeSelect.trigger('change.select2');
        },
        error: function(xhr, status, error) {
          showError(dateSelect, xhr, status);
        }
      });
    });


    dateSelect.on('select2:select', function () {
      timesRequest?.abort();
      jQuery('.offline-ajax-error').remove();
      timeSelect.empty().append(new Option('Завантаження...', '')).prop('disabled', true).trigger('change');
      const placeId = placeSelect.val();
      const dateId      = jQuery(this).val();

      if (!placeId) return;

      timesRequest = jQuery.ajax({
        url: rcData.ajaxUrl,
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'get_course_time_by_date',
          place_id: placeId,
          date_id: dateId,
        },
        success: function(response) {
          if (!response.success || !response.data) { showError(timeSelect, {}, 'error'); return; }

          const times = response.data.times || [];

          timeSelect.empty();
          if (times.length) {
            times.forEach(function (item_time) {
              const option = new Option(item_time.time, item_time.id, false, false);
              timeSelect.append(option);
            });
            timeSelect.prop('disabled', false);
          } else {
            timeSelect.append(new Option('Немає доступного часу', '', false, false)).prop('disabled', true);
          }

          dateSelect.trigger('change.select2');
          timeSelect.trigger('change.select2');
        },
        error: function(xhr, status, error) {
          showError(timeSelect, xhr, status);
        }
      });
    });


  });
};

export default select2;
